import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';

export default class NoAddNewTransferModal extends Component {
  render() {
    const { isOpen, toggle } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Cannot add another step</ModalHeader>
        <ModalBody>
          <p>
            You can't add another step as the last step already goes to a uni tank which consolidates this lot (meaning
            there are no more possible transfers against any lot with this schedule).
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggle}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/transferScheduleForm/noAddNewTransferModal.jsx